import styled from 'styled-components';

import { TABLE_GRID } from 'modules/workflowIndex/constants';

import { GridRow } from 'ui/indexPages/tables/grid';
import { Skeleton } from 'ui/skeleton';
import { colors, spacing } from 'ui/theme';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { Overflow } from 'ui/icons';
import { SecondaryButton } from 'ui/button';

import { TableCell } from './TableCell';

const StyledTableCell = styled(TableCell)`
  height: ${spacing.x3};
`;

const StyledButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;

const SkeletonCell = () => (
  <StyledTableCell>
    <Skeleton />
  </StyledTableCell>
);

export const WorkflowSkeletonRow = () => (
  <GridRow data-test="workflow-skeleton-row" gridLayout={TABLE_GRID}>
    <TableCell data-test="checkbox-grid-cell">
      <Checkbox status={CHECKBOX_STATUS.UNCHECKED} isDisabled />
    </TableCell>
    <SkeletonCell />
    <SkeletonCell />
    <SkeletonCell />
    <SkeletonCell />
    <SkeletonCell />
    <TableCell>
      <StyledButton onClick={() => null} isDisabled>
        <Overflow color={colors.grey90} />
      </StyledButton>
    </TableCell>
  </GridRow>
);
